var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { MenuItem } from './MenuItem';
import { ScreenSize, useScreenSize } from '../../../hooks/useScreenSize';
import { device } from '../../../breakpoints';
import { colors } from '../../../../../abstracts';
var StyledNav = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  margin: auto;\n\n  @media ", " {\n    flex-direction: column;\n    width: 100%;\n    margin: initial;\n  }\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    @media ", " {\n      flex-direction: column;\n    }\n  }\n"], ["\n  position: relative;\n  margin: auto;\n\n  @media ", " {\n    flex-direction: column;\n    width: 100%;\n    margin: initial;\n  }\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    @media ", " {\n      flex-direction: column;\n    }\n  }\n"])), device.laptop, device.laptop);
var StyledActiveUnderline = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0px;\n  width: 0;\n  height: 0px;\n  opacity: 0;\n  transition: transform 0ms 0ms;\n  ", "\n\n  @media ", " {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  bottom: 0px;\n  width: 0;\n  height: 0px;\n  opacity: 0;\n  transition: transform 0ms 0ms;\n  ", "\n\n  @media ", " {\n    display: none;\n  }\n"])), function (_a) {
    var isMegaMenuActive = _a.isMenuActive, width = _a.width, xPos = _a.xPos;
    return isMegaMenuActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: ", ";\n      transform: translateX(", "px);\n      width: ", "px;\n      opacity: 1;\n      height: 2px;\n      transition: width 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n    "], ["\n      background: ", ";\n      transform: translateX(", "px);\n      width: ", "px;\n      opacity: 1;\n      height: 2px;\n      transition: width 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n    "])), colors.black, xPos, width);
}, device.laptop);
var NavMenuBackground = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n  box-shadow: 0px 20px 20px rgb(0 0 0 / 5%);\n  width: 100vw;\n  left: 0;\n  z-index: 0;\n  right: 0;\n  position: fixed;\n  margin: auto;\n  max-width: 1060px;\n  opacity: 0;\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  top: -9999px;\n  opacity: 0;\n  height: 0px;\n  transform: scaleX(0.5);\n  transition: top 0ms 300ms,\n    opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n    height 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n    transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n  ", "\n  @media ", " {\n    display: none;\n  }\n"], ["\n  background: ", ";\n  box-shadow: 0px 20px 20px rgb(0 0 0 / 5%);\n  width: 100vw;\n  left: 0;\n  z-index: 0;\n  right: 0;\n  position: fixed;\n  margin: auto;\n  max-width: 1060px;\n  opacity: 0;\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  top: -9999px;\n  opacity: 0;\n  height: 0px;\n  transform: scaleX(0.5);\n  transition: top 0ms 300ms,\n    opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n    height 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n    transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n  ", "\n  @media ", " {\n    display: none;\n  }\n"])), colors.white, function (_a) {
    var isMegaMenuActive = _a.isMenuActive, height = _a.height;
    return isMegaMenuActive && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      top: calc(4.5rem + 1px);\n      height: ", "px;\n      opacity: 1;\n      transform: scaleX(1);\n      transition: top 0ms 0ms,\n        opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        height 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n    "], ["\n      top: calc(4.5rem + 1px);\n      height: ", "px;\n      opacity: 1;\n      transform: scaleX(1);\n      transition: top 0ms 0ms,\n        opacity 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        height 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms,\n        transform 300ms cubic-bezier(0.68, 0.12, 0.24, 0.99) 0ms;\n    "])), height);
}, device.laptop);
export var NavMenu = function (_a) {
    var items = _a.items, isNavMenuActive = _a.isNavMenuActive, setNavMenuActive = _a.setNavMenuActive;
    var _b = useState(0), menuHeight = _b[0], setMenuHeight = _b[1];
    var _c = useState({
        width: 0,
        xPos: 0
    }), activeUnderline = _c[0], setActiveUnderline = _c[1];
    var _d = useState(true), isSubNavOpen = _d[0], setIsSubNavOpen = _d[1];
    var _e = useState(items[0]), currentItem = _e[0], setCurrentItem = _e[1];
    var screenSize = useScreenSize();
    var openMenuItem = function (item) {
        if (item.id !== currentItem.id) {
            updateActiveUnderline(item.id);
            updateMenuBackground(item.id);
        }
        //TODO Sibling Dependency
        //setIsMyAccountMenuActive(false);
        setCurrentItem(item);
        setNavMenuActive(item.hasChevron); // FIX: we need another indication for this
    };
    var closeItem = function () {
        setActiveUnderline({
            width: 0,
            xPos: 0
        });
        setCurrentItem({});
        setMenuHeight(0);
    };
    var toggleItem = function (item) {
        return item.id === currentItem.id ? closeItem() : openMenuItem(item);
    };
    var handleKeyDown = function (e, item) {
        switch (e.nativeEvent.code) {
            case 'Escape':
                closeItem();
                break;
            case 'Space':
            case 'Enter':
                e.preventDefault();
                isNavMenuActive && isSelected(item) ? closeItem() : openMenuItem(item);
                break;
        }
    };
    var handleMouseEnter = useCallback(function (item) { return function () {
        if (screenSize === ScreenSize.Large) {
            openMenuItem(item);
        }
    }; }, [openMenuItem, items]);
    var handleMouseLeave = function () {
        if (screenSize === ScreenSize.Large) {
            closeItem();
        }
    };
    var handleClick = function (item) {
        if (item) {
            toggleItem(item);
            setIsSubNavOpen(!isSubNavOpen);
        }
    };
    var updateMenuBackground = function (itemId) {
        var el = document.querySelector('#' + itemId);
        var menuEl = el.nextElementSibling;
        if (menuEl) {
            var elHeight = menuEl.offsetHeight;
            setMenuHeight(elHeight);
        }
    };
    var updateActiveUnderline = function (itemId) {
        var el = document.querySelector('#' + itemId);
        if (el) {
            var elWidth = el.offsetWidth - 32;
            var elXPos = el.offsetLeft + 16;
            setActiveUnderline({
                width: elWidth,
                xPos: elXPos
            });
        }
    };
    var isSelected = function (item) { return item.id === currentItem.id; };
    useEffect(function () {
        if (currentItem.id) {
            var item = document.getElementById(currentItem.id);
            item === null || item === void 0 ? void 0 : item.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'start'
            });
        }
    }, [currentItem.id]);
    return (React.createElement(StyledNav, { "aria-label": "Main menu", onMouseLeave: handleMouseLeave },
        items && (React.createElement("ul", { role: "menu" }, items.map(function (i) { return (React.createElement(MenuItem, { item: i, key: i.id, hasChevron: i.hasChevron, isSelected: isSelected(i), isNavMenuActive: isNavMenuActive, isMenuActive: false, onKeyDown: function (e) { return handleKeyDown(e, i); }, onMouseEnter: handleMouseEnter(i), onClick: function () { return handleClick(i); }, openMenuItem: openMenuItem, closeNavMenu: closeItem })); }))),
        React.createElement(StyledActiveUnderline, { width: activeUnderline.width, xPos: activeUnderline.xPos, isMenuActive: isNavMenuActive }),
        React.createElement(NavMenuBackground, { isMenuActive: isNavMenuActive, height: menuHeight })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
